module.exports = __webpack_public_path__ + "img/ligaportal.aa9d0b0b.svg";